import React, { useState, createContext, useContext, useEffect, useMemo } from 'react';
import { Accordion, Button, Form } from 'react-bootstrap';
import { loadJson } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { JSONContext } from '../Store';
import configAdmin from './admin/configAdmin.json';
import { getFilterVariables, getDerivedVariables, executeMobility, getPageContent } from './admin/apiCalls';
import { store, StateProvider } from '../Store';
import { buildQuery } from './queryTemplates';

const { MOBILITYPAGE_CODE } = configAdmin;

export default function MobilityModuleForm(props) {

  const { state, dispatch } = useContext(store);
  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;

  const [configData, setConfigData] = useState(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));

  const {
    setResponseJSON,
    setTextSPC,
    setFormTypeQuery,
    setIsLoading,
    formData,
    setFormData,
    setFirstResponseJSON
  } = useContext(JSONContext);

  const [filterVariables, setFilterVariables] = useState([]); 
  const [derivedVariables, setDerivedVariables] = useState([]); 
  const [validated, setValidated] = useState(false);
  const [derivedCheckboxes, setDerivedCheckboxes] = useState({});
  const [filterCheckboxes, setFilterCheckboxes] = useState({});
  const [textContent, setTextContent] = useState({});

  const navigate = useNavigate();
  const defaultDA = (configData?.enabledDA && configData.enabledDA.length > 0) ? configData.enabledDA[0] : 'DAM';
  const defaultCensus = configData?.dbAlias?.find((item) => item.enabledMobility)?.name || configData?.dbAlias?.[0]?.name || '';

  // reset form values when page loads
  useEffect(() => {
    setConfigData(JSON.parse(localStorage.getItem(STORAGE_CONFIG)));
    getFilterVariables().then(setFilterVariables);
    getDerivedVariables().then(setDerivedVariables);
    getPageContent(setTextContent, MOBILITYPAGE_CODE);
  }, []);

  useEffect(() => {
    if (!configData) {
      return;
    }

    setFormData((prevFormData) => {
      const previous = prevFormData || {};

      return {
        ...previous,
        selectedDA: previous.selectedDA || defaultDA,
        selectedCensus: previous.selectedCensus || defaultCensus,
        selectedPopulationWeight: previous.selectedPopulationWeight || ''
      };
    });
  }, [configData, setFormData, defaultDA, defaultCensus]);

  const styleTheme = {
    'button': `${configData?.theme && configData.theme}-button`,
    'title': `${configData?.theme && configData.theme}-title`,
    'checkButton': `${configData?.theme && configData.theme}-form-check-input`,
    'formGroup': `${configData?.theme && configData.theme}-odisea-form-group`,
  }

  let DATypeFormSet = {
    label: 'División Administrativa:',
    controlType: "radio",
    controlClassName: "form-radio",
    name: "damedam",
    items: []
  };
  configData?.enabledDA && configData.enabledDA.map((item) => {
    DATypeFormSet.items.push(
      {id: "edit-damedam-" + item, value: item, label: "Distrito - " + item}
    )
  });

  const DALabels = {
    'DAM': configData?.DALabels ? `${configData.DALabels["DAM"]} (DAM)` : 'Departamento (DAM)',
    'DAMI': configData?.DALabels ? `${configData.DALabels["DAMI"]} (DAMI)` : 'Provincia (DAMI)',
    'DAME': configData?.DALabels ? `${configData.DALabels["DAME"]} (DAME)` : 'Distrito (DAME)',
  };

  const mobilityTypeFormSet = {
    label: 'Tipo de Movilidad:',
    controlType: "radio",
    controlClassName: "form-radio",
    name: "population",
    items: []
  };

  if (textContent?.additionalData?.enabledTypes) {
    mobilityTypeFormSet.items = textContent.additionalData.enabledTypes.includes("labPop") ? [...mobilityTypeFormSet.items, {id: "edit-population-lab-pop", value: "lab-pop", label: "Laboral"}] : [...mobilityTypeFormSet.items];
    mobilityTypeFormSet.items = textContent.additionalData.enabledTypes.includes("eduPop") ? [...mobilityTypeFormSet.items, {id: "edit-population-edu-pop", value: "edu-pop", label: "Educación"}] : [...mobilityTypeFormSet.items];
  }

  const populationWeightsConfig = textContent?.additionalData?.populationWeights;

  const populationWeightOptions = useMemo(() => {
    if (!populationWeightsConfig?.enabled) {
      return [];
    }

    const rawItems = populationWeightsConfig.items;
    const itemsArray = Array.isArray(rawItems)
      ? rawItems
      : (rawItems && typeof rawItems === 'object'
        ? Object.values(rawItems)
        : []);

    return itemsArray
      .filter((item) => item && item.label && item.label.trim() !== '')
      .map((item, itemIndex) => ({
        id: `population-weight-${itemIndex}`,
        value: item?.value !== undefined && item?.value !== null ? `${item.value}` : '',
        label: item.label
      }));
  }, [populationWeightsConfig]);

  const populationWeightFormSet = populationWeightOptions.length ? {
    label: 'Ponderador de Población',
    name: 'population-weight',
    items: populationWeightOptions
  } : null;

  useEffect(() => {
    if (populationWeightOptions.length === 0) {
      setFormData((prev) => {
        if (!prev?.selectedPopulationWeight) {
          return prev;
        }
        return {
          ...prev,
          selectedPopulationWeight: ''
        };
      });
      return;
    }

    setFormData((prev) => {
      if (!prev) {
        return prev;
      }

      const hasSelection = populationWeightOptions.some((option) => option.value === prev.selectedPopulationWeight);
      if (hasSelection) {
        return prev;
      }

      return {
        ...prev,
        selectedPopulationWeight: populationWeightOptions[0].value
      };
    });
  }, [populationWeightOptions, setFormData]);

  /*
  const applyFilters = (spcText) => {
    let newSpcText = spcText;
    if (formData?.selectedFilterClasses && formData.selectedFilterClasses.length > 0) {
      let fullNewFilterList = []
      formData.selectedFilterClasses.map((item) => {
        fullNewFilterList.push(`${filterVariables[formData.selectedFilterFeature]['variableName']} = ${item}`);
      });

      newSpcText = spcText.replace(/SELECTION ALL/gi, `filter ${fullNewFilterList.join(' OR ')}`)
    }

    return (newSpcText);
  };
  */

  const parseFilters = () => {
    let result = '';
    if (formData?.selectedFilterClasses && formData.selectedFilterClasses.length > 0) {
      let fullNewFilterList = []
      formData.selectedFilterClasses.map((item) => {
        fullNewFilterList.push(`${filterVariables[formData.selectedFilterFeature]['variableName']} = ${item}`);
      });

      result = `${fullNewFilterList.join(' OR ')}`
    }

    return (result);
  };

  const submitForm = () => {

    if (
      !formData?.selectedMobility ||
      !formData?.selectedResultType ||
      (formData?.selectedResultType && formData.selectedResultType.length === 0)
    ) {
      alert('Debe completar todos los campos obligatorios del formulario');
      return -1;
    }

    setFormTypeQuery('mobility');
    let titleLabel = '';
    // let newSpc = 'RUNDEF JOB\nSELECTION ALL\n';
    // newSpc = applyFilters(newSpc);

    let redatamQueries = [];

    const Allfilters = parseFilters();

    // iterate for derived tables
    if (formData?.selectedDerivedClasses && formData.selectedDerivedClasses.length > 0) {
      formData.selectedDerivedClasses.map((item, itemIndex) => {
        if (formData.selectedResultType.includes('matrix')) {
          
          // Build the title
          if (formData.selectedMobility === 'lab-pop') {
            titleLabel = `Matriz origen-destino, según lugar donde trabaja | ${formData.selectedDA}`;
          } else {
            titleLabel = `Matriz origen-destino, según lugar donde estudia | ${formData.selectedDA}`;
          }
          titleLabel = `${titleLabel} | ${derivedVariables[formData.selectedDerivedFeature]['selectLabel']} = ${derivedVariables[formData.selectedDerivedFeature]['checkItems'].filter(derivedItem => derivedItem.variableValue === item)[0]['label']}`;

          redatamQueries = [
            ...redatamQueries,
            {
              queryType: 'mobility',
              resultType: formData.selectedMobility === 'lab-pop' ? 'matrixWork' : 'matrixEducation',
              daType: formData.selectedDA,
              tableName: `matrix${itemIndex}`,
              titleLabel: titleLabel,
              indexNumber: `${itemIndex}`,
              selectedPopulationWeight: formData.selectedPopulationWeight,
              filterText: `${derivedVariables[formData.selectedDerivedFeature]['variableName']} = ${item}`  + (Allfilters !== '' ? ` AND (${Allfilters})` : ''),
              outputNameJSON: `matrix-${itemIndex}`
            }
          ];

        }
    
        if (formData.selectedResultType.includes('indicators')) {
          
          // Build the title
          if (formData.selectedMobility === 'lab-pop') {
            titleLabel = `Indicadores de movilidad cotidiana según lugar de trabajo | ${formData.selectedDA}`;
          } else {
            titleLabel = `Indicadores de movilidad cotidiana según lugar de estudio | ${formData.selectedDA}`;
          }
          titleLabel = `${titleLabel} | ${derivedVariables[formData.selectedDerivedFeature]['selectLabel']} = ${derivedVariables[formData.selectedDerivedFeature]['checkItems'].filter(derivedItem => derivedItem.variableValue === item)[0]['label']}`;

          redatamQueries = [
            ...redatamQueries,
            {
              queryType: 'mobility',
              resultType: formData.selectedMobility === 'lab-pop' ? 'indexWork' : 'indexEducation',
              daType: formData.selectedDA,
              tableName: `index${itemIndex}`,
              titleLabel: titleLabel,
              indexNumber: `${itemIndex}`,
              selectedPopulationWeight: formData.selectedPopulationWeight,
              filterText: `${derivedVariables[formData.selectedDerivedFeature]['variableName']} = ${item}` + (Allfilters !== '' ? ` AND (${Allfilters})` : ''),
              outputNameJSON: `index-${itemIndex}` // outputNameJSON
            }
          ];
        }
          
      });
    } else {
      if (formData.selectedResultType.includes('matrix')) {
        
        // Build the title
        if (formData.selectedMobility === 'lab-pop') {
          titleLabel = `Matriz origen-destino, según lugar donde trabaja | ${formData.selectedDA}`;
        } else {
          titleLabel = `Matriz origen-destino, según lugar donde estudia | ${formData.selectedDA}`;
        }

        redatamQueries = [
          ...redatamQueries,
          {
            queryType: 'mobility',
            resultType: formData.selectedMobility === 'lab-pop' ? 'matrixWork' : 'matrixEducation',
            daType: formData.selectedDA,
            tableName: `matrix0`,
            titleLabel: titleLabel,
            indexNumber: `0`,
            selectedPopulationWeight: formData.selectedPopulationWeight,
            filterText: Allfilters,
            outputNameJSON: `matrix-0`
          }
        ];

      }
  
      if (formData.selectedResultType.includes('indicators')) {

        // Build the title
        if (formData.selectedMobility === 'lab-pop') {
          titleLabel = `Indicadores de movilidad cotidiana según lugar de trabajo | ${formData.selectedDA}`;
        } else {
          titleLabel = `Indicadores de movilidad cotidiana según lugar de estudio | ${formData.selectedDA}`;
        }

        redatamQueries = [
          ...redatamQueries,
          {
            queryType: 'mobility',
            resultType: formData.selectedMobility === 'lab-pop' ? 'indexWork' : 'indexEducation',
            daType: formData.selectedDA,
            tableName: `index0`,
            titleLabel: titleLabel,
            indexNumber: `0`,
            selectedPopulationWeight: formData.selectedPopulationWeight,
            filterText: Allfilters,
            outputNameJSON: `index-0`
          }
        ];

      }
    }
    

    setIsLoading(true);

    executeMobility({
      databaseAlias: formData.selectedCensus,
      queryData: redatamQueries
    }, (resp) => {
      //setResponseJSON(resp);
      //console.log(resp);
      let result = {};
      try {
        result = JSON.parse(resp);
      } catch {
        //result = {type: 'Exception', message: 'Error en respuesta desde el servidor'};
        result = {type: 'Exception', message: 'Error en respuesta desde el servidor \n\n' + resp};
      }

      // if (result?.type && result.type === 'Exception') {
      //   result?.message && alert('ERROR EN EL SERVIDOR: ' + result.message);
      //   navigate(-1);
      // }
      
      result?.query && setTextSPC(result.query);
      result?.response && setFirstResponseJSON(result.response); // first response

      // set responses to empty
      setResponseJSON([]);

      // call the API for each result
      const requests = result.response.outputs.map(async (outputItem) => {
        let responses = {
          path: '',
          data: ''
        }

        await loadJson(result.response.redsessionid, outputItem.file, (jsonResult) => {
          responses.path = `${result.response.redsessionid}/${outputItem.file}`;
          responses.data = jsonResult;
        });
        
        return responses;
      })
      
      // when API finishes loading, set statuses
      Promise.all(requests).then((requests) => {
        setResponseJSON(requests);
        setIsLoading(false);
      });
    });

    navigate('/visualizations');
  }

  let censusFormSet = {
    label: 'Base de datos:',
    controlType: "radio",
    controlClassName: "form-radio",
    name: "edit-census",
    items: []
  };
  configData?.dbAlias && configData.dbAlias.map((item) => {
    item.enabledMobility && censusFormSet.items.push(
      {id: "edit-census-" + 1, value: item.name, label: item.label}
    )
  });


  const resultTypeFormSet = {
    label: 'Tipo de resultado',
    controlType: "checkbox",
    controlClassName: "form-checkbox",
    name: "output[matrix-indicators]",
    items: [
      {id: "edit-output-matrix", value: "matrix", label: "Matriz básica"},
      {id: "edit-output-indicators", value: "indicators", label: "Indicadores"}
    ]
  };

  // validate submit form  
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const submitText = 'Ejecutar';
  const emptySelectText = '- Seleccionar -';

  return (
    <>
    {/* JSON.stringify(formData) */}
    <h3> Seleccione Parámetros </h3>
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
    <div className="odisea-parent">
      <div className="odisea-child1">
    <Accordion defaultActiveKey={['0']} alwaysOpen>
      <Accordion.Item className="odisea-form-accordion-item" eventKey="0">
        <Accordion.Header className={ "odisea-form-accordion-header " + styleTheme.title}>Datos obligatorios*</Accordion.Header>
        <Accordion.Body>
        <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            <Form.Label className="odisea-form-label" htmlFor="edit-filters">{ censusFormSet.label }</Form.Label>
            <Form.Select
              id="edit-alias"
              name="alias"
              value={formData?.selectedCensus || defaultCensus}
              onChange={ (e) => {
                  setFormData((prev) => ({
                    ...prev,
                    selectedCensus: e.target.value
                  }));
              } }
            >
              { censusFormSet.items.map((item, itemId) => <option key={ item.id } value={ item.value }>{ item.label }</option>) }
            </Form.Select>
          </Form.Group>
          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
             <Form.Label className="odisea-form-label" htmlFor="edit-filters">{ DATypeFormSet.label }</Form.Label>
            <Form.Select
              id="edit-alias"
              name="alias"
              value={formData?.selectedDA || defaultDA}
              onChange={ (e) => {
                  setFormData((prev) => ({
                    ...prev,
                    selectedDA: e.target.value
                  }));
              } }
            >
              { DATypeFormSet.items.map((item, itemId) => <option key={ item.id } value={ item.value }>{ DALabels[item.value] }</option>) }
            </Form.Select>
          </Form.Group>

          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            <Form.Label className="odisea-form-label" htmlFor="edit-filters">{ mobilityTypeFormSet.label }</Form.Label>
            { mobilityTypeFormSet.items.map((item, itemIndex) => 
              <Form.Check
                className={ styleTheme.checkButton } 
                required
                key={ itemIndex }
                type={ mobilityTypeFormSet.controlType }
                id={ item.id }
                label={ item.label }
                name={ mobilityTypeFormSet.name }
                value={ item.value }
                onChange={ (e) => {
                  if (e.target.checked){
                    setFormData({
                      ...formData,
                      selectedMobility: e.target.value
                    });
                  }
                } }
              />
            )}                   
          </Form.Group>

          { populationWeightFormSet && (
            <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
              <Form.Label className="odisea-form-label" htmlFor="edit-population-weight">{ populationWeightFormSet.label }</Form.Label>
              <Form.Select
                id="edit-population-weight"
                name={ populationWeightFormSet.name }
                value={ formData?.selectedPopulationWeight || '' }
                onChange={ (e) => {
                  setFormData({
                    ...formData,
                    selectedPopulationWeight: e.target.value
                  });
                } }
              >
                { populationWeightFormSet.items.map((item) => <option key={ item.id } value={ item.value }>{ item.label }</option>) }
              </Form.Select>
            </Form.Group>
          )}

          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            <Form.Label className={ 'odisea-form-label' } htmlFor="">{ resultTypeFormSet.label }</Form.Label>
            { resultTypeFormSet.items.map((item) => 
            <Form.Check
            className={ styleTheme.checkButton }
            type={ resultTypeFormSet.controlType }
            id= { item.id }
            label={ item.label }
            name={ resultTypeFormSet.name }
            value={ item.value }
            onChange={ (e) => {
              let selectedResultTypeList = []
              if (formData.hasOwnProperty('selectedResultType')) {
                selectedResultTypeList = formData.selectedResultType;
              }
              if (e.target.checked){
                setFormData({
                  ...formData,
                  selectedResultType: [...selectedResultTypeList, e.target.value]
                });
              } else {
                setFormData({
                  ...formData,
                  selectedResultType: selectedResultTypeList.filter(item => item !== e.target.value)
                });
              }
            }}
            />
            )}  
          </Form.Group>
        </Accordion.Body>
      </Accordion.Item>
      </Accordion>
    </div>
    <div className="odisea-child2">
    <Accordion defaultActiveKey={['0']} alwaysOpen>
    <Accordion.Item className="odisea-form-accordion-item" eventKey="1">
      <Accordion.Header className={ "odisea-form-accordion-header " + styleTheme.title }>Filtros opcionales</Accordion.Header>
        <Accordion.Body>
          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            <Form.Label className={ 'odisea-form-label' } htmlFor="edit-filters">{ 'Derivada por' }</Form.Label>
            <Form.Select
              id="edit-alias"
              name="alias"
              className="form-select"
              onChange={ (e) => {
                setFormData({
                  ...formData,
                  selectedDerivedFeature: e.target.value,
                  selectedDerivedClasses: [],
                  selectedDerivedClassesLabels: []
                })
                
                setDerivedCheckboxes(derivedVariables[e.target.value]);
              } }
              >
              <option value="" defaultValue="selected">{ emptySelectText }</option>
              { derivedVariables.map((item, itemId) => <option key={ item.id } value={ itemId }>{ item.selectLabel }</option>) }
              </Form.Select>
          </Form.Group>
          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            {/*<Form.Label className={ 'odisea-form-label' } htmlFor="edit-filters">{ derivedCheckboxes.label }</Form.Label>*/}
            { derivedCheckboxes?.checkItems && derivedCheckboxes.checkItems.map((item) => 
            <Form.Check
            className={ styleTheme.checkButton } 
              type={ derivedCheckboxes.controlType }
              key={ item.id }
              label={ item.label }
              name={ derivedCheckboxes.name }
              value={ item.variableValue }
              onChange={ (e) => {
              let selectedDerivedClasses = [];
              let selectedDerivedClassesLabels = [];

              if (formData.hasOwnProperty('selectedDerivedClasses')) {
                selectedDerivedClasses = formData.selectedDerivedClasses;
                selectedDerivedClassesLabels = formData.selectedDerivedClassesLabels;
              }
              if (e.target.checked){
                setFormData({
                  ...formData,
                  selectedDerivedClasses: [...selectedDerivedClasses, e.target.value],
                  selectedDerivedClassesLabels: [...selectedDerivedClassesLabels, item.label]
                });
              } else {
                setFormData({
                  ...formData,
                  selectedDerivedClasses: selectedDerivedClasses.filter(item => item !== e.target.value),
                  selectedDerivedClassesLabels: selectedDerivedClassesLabels.filter(i => i !== item.label)
                });
              }
              } }
              />
              )}  
          </Form.Group>
          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
          <Form.Label className="odisea-form-label" htmlFor="edit-filters">Filtrar por: </Form.Label>
            <Form.Select
              id="edit-alias"
              name="alias"
              className="form-select"
              onChange={ (e) => {
                setFormData({
                  ...formData,
                  selectedFilterFeature: e.target.value,
                  selectedFilterClasses: []
                })
                
                setFilterCheckboxes(filterVariables[e.target.value]);
              } }
              >
              <option value="" defaultValue="selected">{ emptySelectText }</option>
              { filterVariables.map((item, itemId) => <option key={ item.id } value={ itemId }>{ item.selectLabel }</option>) }
            </Form.Select>
          </Form.Group>
          <Form.Group className={"odisea-form-group test " + styleTheme.formGroup}>
            {/*<Form.Label className={ 'odisea-form-label' } htmlFor="edit-filters">{ filterCheckboxes.label }</Form.Label>*/}
            { filterCheckboxes?.checkItems && filterCheckboxes.checkItems.map((item, itemId) => 
              <Form.Check
              className={ styleTheme.checkButton } 
                type={ filterCheckboxes.controlType }
                key={ itemId }
                label={ item.label }
                name={ filterCheckboxes.name }
                value={ item.variableValue }
              onChange={ (e) => {
              let selectedFilterClasses = []
              if (formData.hasOwnProperty('selectedFilterClasses')) {
              selectedFilterClasses = formData.selectedFilterClasses;
              }
              if (e.target.checked){
              setFormData({
              ...formData,
              selectedFilterClasses: [...selectedFilterClasses, e.target.value]
              });
              } else {
              setFormData({
              ...formData,
              selectedFilterClasses: selectedFilterClasses.filter(item => item !== e.target.value)
              });
              }
              } }
              />
            )}  
          </Form.Group>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
    <Form.Group className="odisea-form-group odisea-form-group-button">
      <Button type="submit" className={ "odisea-form-button-submit " + styleTheme.button } onClick={() => {submitForm()}}>{submitText}</Button>
    </Form.Group>
      </div>
    </div>
    </Form>
    </>
    )
}
